import JDate from "jalali-date";
import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  ButtonGroup,
  Card,
  Col,
  Container,
  Dropdown,
  ListGroup,
  Row,
} from "react-bootstrap";
import "react-confirm-alert/src/react-confirm-alert.css";
import Context from "../Context";
import { export_to_doc } from "../Drivers/MSWord";
import Description from "../Elements/allContent";
import ConfirmationModal from "../Elements/ConfirmationModal";
import CreateDocument from "../Elements/CreateDocument";
import DocumentItem from "../Elements/DocumentItem";
import Header from "../Elements/Header";
import InputCSL from "../Elements/InputCSL";
import Rating from "../Elements/Rating";
import { downloadBibtex } from "../Libs/Bibtex";
import { downloadRIS } from "../Libs/RIS";
import Document1 from "../Lottie/Document1";

const jdate = new JDate();
export default () => {
  const context = useContext(Context);
  const [active_csl, set_active_csl] = useState(null);
  const [imported_csls, set_imported_csls] = useState([]);

  const loadDefaultCsls = () => {
    context.ApiDriver.getCsls(
      { default: true },
      ({ data }) => {
        set_imported_csls(data);
        set_active_csl(data[0]);
      },
      error => {},
    );
  };
  useEffect(loadDefaultCsls, []);

  // const [history, set_history] = useState(config.default_history);
  const [history, set_history] = useState(
    JSON.parse(localStorage.getItem("history") || "[]"),
  );

  useEffect(() => {
    localStorage.setItem("history", JSON.stringify(history));
  }, [history]);

  const [citeproc_loading, set_citeproc_loading] = useState(true);
  const [citeproc, set_citeproc] = useState([]);
  const fetchCiteProc = () => {
    if (active_csl === null || history.length === 0) return;
    const payload = history;
    payload.reduce((acc, curr) => {
      if (curr.author) {
        const authors = curr.author;
        curr.author = [];
        // eslint-disable-next-line array-callback-return
        authors.map(item => {
          if (!curr[item.position]) {
            curr[item.position] = [];
          }
          curr[item.position].push(item);
        });
      }
      if (!acc) {
        acc = [];
      }
      acc.push(curr);
      return acc;
    }, []);
    set_citeproc_loading(true);
    context.ApiDriver.generateCitationBoth(
      {
        csl_id: active_csl.id,
        data: payload,
      },
      data => {
        set_citeproc(data);
        set_citeproc_loading(false);
      },
    );
  };

  const removeAll = () => {
    context.showConfirmationModal(
      "حذف همه",
      "مطمئنید که می‌خواهید همه آیتم‌ها را حذف کنید؟",
      [
        {
          label: "بله",
          onClick: () => {
            set_history([]);
            set_citeproc([]);
          },
          variant: "danger",
        },
        {
          label: "خیر",
          onClick: () => {},
        },
      ],
    );
  };
  const createdItem = item => {
    set_history(history.concat([item]));
  };
  const go_to_download_pajoohyar = () => {
    // clciked_on_download(2);
    window.location = "https://pajoohyar.ir/product";
  };
  useEffect(fetchCiteProc, [
    JSON.stringify(active_csl || {}),
    JSON.stringify(history),
  ]);
  return [
    <div>
      <Header key="header" />
      <div key="content">
        <Row
          style={{
            marginTop: 0,
            marginLeft: 0,
            marginRight: 0,
            backgroundColor: "rgb(238, 238, 238)",
          }}>
          {/* <Col className="myLibrary" md={{ span: 9 }}>
            {profile ? (
              <h3 style={{ color: "#43a294" }}>
                کتابخانه {profile.first_name} {profile.last_name}
              </h3>
            ) : (
              <h3 style={{ color: "#43a294" }}>کتابخانه من</h3>
            )}
          </Col> */}
          <Col md={{ span: 12 }}>
            <Card
              style={{ backgroundColor: "rgb(238, 238, 238)", border: "none" }}
              className="cite__myCitation">
              <Container className="cite__myCitation">
                <Card.Body className="cite__myCitation">
                  {history.length > 0 ? (
                    <Row>
                      <Col
                        md={12}
                        style={{ minHeight: 200 }}
                        className="cite__myCitation">
                        {citeproc_loading ? (
                          <Document1 />
                        ) : (
                          <Row>
                            <Col md={12} className="cite__myCitation">
                              <ListGroup>
                                {citeproc.map((item, index) => (
                                  <DocumentItem
                                    key={index}
                                    document={history[index]}
                                    citeproc={item}
                                    updated={document => {
                                      set_history(
                                        history.map((doc, i) =>
                                          i === index ? document : doc,
                                        ),
                                      );
                                    }}
                                    removed={document => {
                                      set_history(
                                        history.filter((doc, i) =>
                                          i === index ? null : doc,
                                        ),
                                      );
                                    }}
                                  />
                                ))}
                              </ListGroup>
                            </Col>
                          </Row>
                        )}
                      </Col>
                    </Row>
                  ) : (
                    <Row style={{ display: "none" }}></Row>
                  )}
                  {history.length > 0 ? (
                    <Row>
                      <Col md={12}>
                        <CreateDocument created={createdItem} />
                      </Col>
                      <Col md={12}>
                        <Row>
                          <Col md={7}>
                            <InputCSL
                              changedCsl={csl => {
                                set_active_csl(csl);
                              }}
                              active_csl={active_csl}
                              imported_csls={imported_csls}
                              set_imported_csls={set_imported_csls}
                            />
                          </Col>
                          <Col md={5} style={{ paddingTop: 10 }}>
                            <ButtonGroup style={{ direction: "ltr" }} size="sm">
                              <Button
                                className="cite__myButtonGroup"
                                style={{ color: "red" }}
                                onClick={removeAll}>
                                حذف همه
                              </Button>
                              <Button
                                className="cite__myButtonGroup"
                                style={{ color: "#ff790c" }}
                                onClick={go_to_download_pajoohyar}>
                                دانلود پژوهیار
                              </Button>
                              <Dropdown
                                className="hide-drop"
                                style={{
                                  display: "inline",
                                  marginLeft: 0,
                                  borderRadius: 0,
                                  backgroundColor: "#eee",
                                }}>
                                <Dropdown.Toggle
                                  variant="info"
                                  id="dropdown-basic"
                                  className="cite__dropDownButton"
                                  style={{
                                    borderRadius: 0,
                                    backgroundColor: "#eee",
                                    color: "#6da7b1",
                                  }}>
                                  <i
                                    className="fa fa-cloud-download"
                                    aria-hidden="true"></i>{" "}
                                  دریافت خروجی
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <Dropdown.Item
                                    onClick={() => {
                                      export_to_doc(
                                        "results",
                                        `pajoohyar_${jdate.format(
                                          "YYYY-MM-DD",
                                        )}_${new Date().getHours()}_${new Date().getMinutes()}`,
                                      );
                                    }}>
                                    <i
                                      className="fa fa-file-word-o"
                                      aria-hidden="true"></i>{" "}
                                    Word
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => {
                                      downloadBibtex(
                                        history,
                                        `pajoohyar_${jdate.format(
                                          "YYYY-MM-DD",
                                        )}_${new Date().getHours()}_${new Date().getMinutes()}`,
                                      );
                                    }}>
                                    <i
                                      className="fa fa-file-excel-o"
                                      aria-hidden="true"></i>{" "}
                                    BibTeX{" "}
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => {
                                      downloadRIS(
                                        history,
                                        `pajoohyar_${jdate.format(
                                          "YYYY-MM-DD",
                                        )}_${new Date().getHours()}_${new Date().getMinutes()}`,
                                      );
                                    }}>
                                    <i
                                      className="fa fa-file-image-o"
                                      aria-hidden="true"></i>{" "}
                                    RIS
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </ButtonGroup>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col md={12}>
                        <CreateDocument created={createdItem} />
                      </Col>
                    </Row>
                  )}
                </Card.Body>
              </Container>
            </Card>
          </Col>
        </Row>
        <Rating />
      </div>
      <Description key="mycontent" />
      <ConfirmationModal />
    </div>,
  ];
};
